export enum AlertType {
    SUCCESS = 'SUCCESS', 
    INFO = 'INFO', 
    WARNING = 'WARNING', 
    ERROR = 'ERROR'
}